import React, { Component, Fragment } from 'react';
import { Link } from 'react-router-dom';
import { Field, reduxForm, formValueSelector,FieldArray } from 'redux-form';
import { connect } from 'react-redux'
import { validate, validators } from 'validate-redux-form';
import { renderField, renderSearchSelect, renderFieldCheck } from 'Utils/renderField/renderField';
import { api } from 'api/api';

let productos = []
const getProductos = (search)  =>{
    return api.get("producto/getFracciones",{search}).catch((error) => {})
            .then((data) => {
                if (data){
                    productos = data.results
                    return data.results
                }
                else{
                    return []
                }
            })
            .catch(e => {
                return []
            })
}


class Productos extends Component {

    getProductos = (search) => {
        const {cuenta_id} = this.props;
        return api.get("producto/getFracciones",{search}).catch((error) => {})
            .then((data) => {
                if (data){
                    productos = data.results
                    return data.results
                }
                else{
                    return []
                }
            })
            .catch(e => {
                return []
            })
    }
  render() {

    return (
      <Fragment>
        <div className="row">
            <div className="col-md-12">
                <div className="col-md-12 col-sm-12">
                    <label htmlFor="Producto" className="m-0">Producto y presentación*:</label>
                </div>
                <div className="col-md-12  form-group">
                    <Field
                        name={`producto`}
                        valueKey="id"
                        labelKey="nombre_completo"
                        label="Producto"
                        component={renderSearchSelect}
                        loadOptions={this.getProductos}
                        />
                </div>
            </div>
        </div>
        {/*<div className="row">
            <div className="col-md-6 row m-0">
                <div className="col-auto m-0 form-group label">
                    <Field name="aplicar_enfermeria" component={renderFieldCheck}
                        type="checkbox"
                        className="form-control"
                        placeholder="Correo"/>
                </div>
                <div className="p-0 col form-group ">
                    <label htmlFor="class">Aplicar en enfermería</label>
                </div>
            </div>
        </div>*/}
      </Fragment>
    )
  }
}

let ProductoForm = props => {
    const { handleSubmit, valores, cuenta_id, editar} = props;
    return(
        <form onSubmit={handleSubmit}>
            <div className="form-group grid-container">
                <div className="padding-15 p-sm-0 pt-sm-1 pb-sm-1">
                    <Productos />
                    <div className="row">
                        <div className="col-12">
                            <div className="d-flex justify-content-end flex-column flex-sm-row align-items-stretch align-items-sm-center">
                                <button type="button" className="btn btn-secondary m-1" onClick={props.closeModal}>Cancelar</button>
                                <button type="button" className="btn btn-primary m-1" onClick={ e =>{
                                    editar ? props.editarProducto(valores) : props.addProducto(valores);
                                    }
                                }>Guardar</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </form>
    )
};
ProductoForm = reduxForm({
    form: 'paquete_producto',
    validate: data => {
        return validate(data, {
        })
    }
})(ProductoForm);
const selector = formValueSelector('paquete_producto');
ProductoForm = connect(state => {
    let valores = null;
    try {
        valores = state.form.paquete_producto.values;
    } catch (error) {
        valores = null;
    }
    return {
        valores
    };
})(ProductoForm);
export default ProductoForm
